import { accentColors } from "./marketingStyles";

/**
 * Static marketing matchup cards — no API. Headshots come from public CDNs
 * in marketingHeadshots.js so the landing page works while logged out.
 */
export const MARKETING_MATCHUPS = [
  {
    sport: "mlb",
    playerA: "Ruth",
    playerB: "Bonds",
    playerIdA: "ruthba01",
    playerIdB: "bondsba01",
    eraA: "1920s",
    eraB: "2000s",
    question: "Greatest slugger ever?",
    accent: accentColors[0],
    delay: "0s",
  },
  {
    sport: "nba",
    playerA: "James",
    playerB: "Jordan",
    playerIdA: "jamesle01",
    playerIdB: "jordami01",
    eraA: "2010s",
    eraB: "1990s",
    question: "NBA GOAT?",
    accent: accentColors[1],
    delay: "0.5s",
  },
  {
    sport: "nfl",
    playerA: "Brady",
    playerB: "Manning",
    playerIdA: "brad06400",
    playerIdB: "peyt01800",
    eraA: "2000s",
    eraB: "2000s",
    question: "Best QB ever?",
    accent: accentColors[2],
    delay: "1s",
  },
  {
    sport: "mlb",
    playerA: "Griffey",
    playerB: "Trout",
    playerIdA: "griffke02",
    playerIdB: "troutmi01",
    eraA: "1990s",
    eraB: "2010s",
    question: "Five-tool icon?",
    accent: accentColors[4],
    delay: "1.5s",
  },
];
